import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.colors.background.muted};
`;

const Content = styled.div`
  text-align: center;
`;

const Title = styled.h1`
  margin-bottom: ${props => props.theme.spacing.lg};
  font-size: ${props => props.theme.typography.fontSize['4xl']};
  font-weight: ${props => props.theme.typography.fontWeight.bold};
  color: ${props => props.theme.colors.text.primary};
`;

const Text = styled.p`
  margin-bottom: ${props => props.theme.spacing.lg};
  font-size: ${props => props.theme.typography.fontSize.xl};
  color: ${props => props.theme.colors.text.muted};
`;

const StyledLink = styled(Link)`
  color: ${props => props.theme.colors.primary.main};
  text-decoration: underline;
  text-underline-offset: 4px;
  transition: ${props => props.theme.transitions.default};
  
  &:hover {
    color: ${props => props.theme.colors.primary.dark};
    opacity: 0.9;
  }
`;

const NotFound = () => {
  return (
    <Container>
      <Content>
        <Title>404</Title>
        <Text>Oops! Page not found</Text>
        <StyledLink to="/">Return to Home</StyledLink>
      </Content>
    </Container>
  );
};

export default NotFound;
